import { ApiResponse } from 'apisauce';
import { IUnifiedFilter } from 'src/contexts/SearchFilterContext';
import { IFailSuccess, ISpeed, IWeight } from 'src/models';

import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import { TGetFsResult, TGetSpeedResult, TGetWeightResult } from './DashboardTypes';

/**
 * # Dashboard Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new DashboardApi();
 *
 * ```
 */
export class DashboardApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getMargin(
    type: string,
    deptSid?: number,
    filter?: IUnifiedFilter,
  ): Promise<TGetWeightResult> {
    try {
      const params = new URLSearchParams();
      if (deptSid !== undefined) params.append('deptSid', String(deptSid));
      if (filter) {
        Object.entries(filter).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            params.append(key, String(value));
          }
        });
      }

      const queryString = params.toString();
      const url = `/v1/dashboard/weight/${type}/margin${queryString ? '?' + queryString : ''}`;

      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      const dashboards: IWeight = response.data.data;
      return { kind: 'ok', dashboards, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getSize(
    type: string,
    deptSid?: number,
    filter?: IUnifiedFilter,
  ): Promise<TGetWeightResult> {
    try {
      const params = new URLSearchParams();
      if (deptSid !== undefined) params.append('deptSid', String(deptSid));
      if (filter) {
        Object.entries(filter).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            params.append(key, String(value));
          }
        });
      }

      const queryString = params.toString();
      const url = `/v1/dashboard/weight/${type}${queryString ? '?' + queryString : ''}`;

      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      const dashboards: IWeight = response.data.data;
      return { kind: 'ok', dashboards, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getSpeed(
    quarterNum: number,
    deptSid?: number,
    filter?: IUnifiedFilter,
  ): Promise<TGetSpeedResult> {
    try {
      const params = new URLSearchParams();
      if (deptSid !== undefined) params.append('deptSid', String(deptSid));
      if (filter) {
        Object.entries(filter).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            params.append(key, String(value));
          }
        });
      }

      const queryString = params.toString();
      const url = `/v1/dashboard/speed/${quarterNum}${queryString ? '?' + queryString : ''}`;

      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      const dashboards: ISpeed = response.data.data;
      return { kind: 'ok', dashboards, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getFs(quarter: number, deptSid?: number, filter?: IUnifiedFilter): Promise<TGetFsResult> {
    try {
      const params = new URLSearchParams();
      if (deptSid !== undefined) params.append('deptSid', String(deptSid));
      if (filter) {
        Object.entries(filter).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            params.append(key, String(value));
          }
        });
      }

      const queryString = params.toString();
      const url = `/v1/dashboard/fs/${quarter}${queryString ? '?' + queryString : ''}`;

      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      const dashboards: IFailSuccess = response.data.data;
      return { kind: 'ok', dashboards, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
